export default "__VITE_ASSET__ef8LnEo$__"